<template>
    <div>
        <CustomRedeemButton
            :isLogin="isLogin"
            :point="availablePoint"
            :selectedPoint="selectedPoint"
            :selectedQuantity="selectedQuantity"
            :lblRedeemBTN="lbl.redeem_button"
            :campaign="campaign"
            :redeemBTN="redeemBTN"
            v-if="isForceRender"
            @clickRedeem="clickRedeem()"
        >
        </CustomRedeemButton>

        <!-- <modal view="redeem-component"
            :busModal="busModal"
            @modalAlertHidden="clickOkModalAlert($event)"></modal> -->
        <confirm-redeem-modal
            :lbl="lbl"
            :campaign="campaign"
            :busModal="busConfirmRedeem"
            @clickConfirmRedeem="clickConfirmRedeem()"
        ></confirm-redeem-modal>
        <!-- <SerialModal :lbl="lbl" :busSerialModal="busSerialModal"></SerialModal> -->

        <AlertModal
            :lbl="lbl"
            :busSerialModal="busSerialModal"
            :afterConfirmLastModal="afterConfirmLastModal"
        ></AlertModal>

        <ErrorModal :lbl="lbl" :busErrorModal="busErrorModal"></ErrorModal>

        <shipping-address-modal
            :lblShipping="lbl.shipping"
            :shippingAddress="shippingAddress"
            :errorInfo="shippingAddressValidateInfo"
            :busShippingModal="busShippingModal"
            @clickConfirmAddress="clickConfirmAddress($event)"
        ></shipping-address-modal>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
// library
import Vue from "vue";
// helper
import Util from "@/helper/Utility.js";
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
// core
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
import {
    CampaignConfigBuilder,
    RedeemConfigBuilder,
    RedeemShippingAdressBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";
// component
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
import CustomRedeemButton from "./CustomRedeemButton.vue";
// Modal
// import Modal from '@/components/Modal/Modal.vue';
import ConfirmRedeemModal from "../modal/ConfirmRedeemModal.vue";
// import SerialModal from "../modal/SerialModal.vue";
import AlertModal from "../modal/AlertModal.vue";
import ErrorModal from "../modal/ErrorModal.vue";
import ShippingAddressModal from "../modal/ShippingAddressModal.vue";
/**
 * Property
 * @property {object} lbl Text for Component.
 * @property {object} campaign Campaign model.
 * @property {number} selectedId Selected campaign for redeem in case of campaign contain sub-campaign.
 * @property {number} selectedQuantity Selected campaign quantity.
 * @property {number} selectedPoint Selected campaign use/get point.
 * Event
 * @event clickRedeem Click validate redeem.
 * @event clickConfirmRedeem Click confirm to proceed redeem define type of campaign.
 * Method
 * @method checkRedeemCondition Check if user can or cannot redeem.
 * @method openWebsite Redirect by campaign condition to website after redeem.
 * @method openSurvey Redirect by campaign condition to website after redeem.
 * @method callInterfaceApi Call api by campaign condition after redeem.
 * @method initialShippingAddress Setup data model and open shipping address modal.
 * @method clickConfirmAddress Validate shipping address and proceed redeem.
 * @method redeem Call redeem api for redeem.
 * @method updateCampaign Call Campaign detail api to update data.
 * @method updateCampaignInfo Emit parent method to update data.
 * @method initialSerialModal Open Serial modal.
 * Utilities
 * @method forceRender Force component to rerender.
 */
export default {
    name: "CustomRedeem",
    components: {
        ModalMaster,
        CustomRedeemButton,
        // Modal,
        ConfirmRedeemModal,
        // SerialModal,
        ShippingAddressModal,
        AlertModal,
        ErrorModal
    },
    props: {
        lbl: Object,
        campaign: Object,
        selectedId: Number,
        selectedQuantity: Number,
        selectedPoint: Number,
        token: String
    },
    data: function() {
        return {
            isLogin: false,
            availablePoint: 0,
            redeemBTN: {
                strRedeemLabel: "",
                isAllowRedeem: true,
                isButtonDisable: false,
                strDisableClass: "redeem-disable",
                isUseDefault: false
            },
            redeemConfig: null,
            redeemShippingAdress: null,
            redeemInfoConfig: null,
            redeemLocation: null,
            redeemOtherConfig: null,
            campaignConfig: null,

            serialCampaign: {},
            isForceRender: true,

            shippingAddress: null,
            shippingAddressValidateInfo: {
                isValid: true,
                msg: ""
            },

            // busModal: new Vue(),
            busConfirmRedeem: new Vue(),
            busSerialModal: new Vue(),
            busErrorModal: new Vue(),
            busShippingModal: new Vue(),
            loadingModal: null
        };
    },
    created: function() {
        // Account.loginStatus().then(status => {
        //     this.isLogin = status;
        // });
        this.availablePoint = Account.getCachePoint();
        this.redeemConfig = new RedeemConfigBuilder().create();
        var modalFactory = new ModalFactory();
        this.modalController = modalFactory.getModalController();
        this.loadingModal = modalFactory.getLoadingModal();
    },
    methods: {
        //Event
        clickRedeem: function() {
            // if (this.selectedPoint <= 0) {
            //     var localFail = this.lbl.after_redeem.titleFail;
            //     this.busErrorModal.$emit("showErrorModal", localFail.noPoint);
            // } else {
            // if (!this.redeemBTN.isAllowRedeem) return;
            //  this.busConfirmRedeem.$emit("showConfirmRedeemModal", {});
            // }
            this.busConfirmRedeem.$emit("showConfirmRedeemModal", {});
        },
        clickConfirmRedeem: function() {
            // if (!this.redeemBTN.isAllowRedeem) return;

            var strRedeemCondition = this.checkRedeemCondition();
            switch (strRedeemCondition) {
                case "open_web":
                    this.openWebsite();
                    break;
                case "open_web_survey":
                    this.openSurvey();
                    break;
                case "call_api":
                    this.callInterfaceApi();
                    //No longer see this being use.
                    break;
                case "update_shipping_address":
                    this.initialShippingAddress();
                    break;
                default:
                    this.redeem();
                    break;
            }
        },
        //Function
        checkRedeemCondition: function() {
            var strResult = "redeem";
            switch (this.campaign.type) {
                case Vue.CampaignType.Buy:
                    strResult = "open_web";
                    break;
                case Vue.CampaignType.Interface:
                    if (!this.campaign.interfaceDisplay) return;

                    if (this.campaign.interfaceDisplay === "web")
                        strResult = "open_web";
                    if (
                        this.campaign.interfaceDisplay === "survey" ||
                        this.campaign.interfaceDisplay === "surveyapprove"
                    )
                        strResult = "open_web_survey";
                    if (this.campaign.interfaceDisplay === "api")
                        strResult = "call_api";
                    break;
                default:
                    if (this.campaign.delivered)
                        strResult = "update_shipping_address";
                    break;
            }

            return strResult;
        },
        openWebsite: function() {
            if (!this.campaign.website) return;

            var bzbsToken = Account.getToken();
            var localeCode = Locale.getLocaleCode();
            var returnUrl = encodeURIComponent(window.location.href);
            switch (this.campaign.type) {
                case Vue.CampaignType.Buy:
                    var strUrl = "";
                    var strLocale = "";
                    var strEncryptToken = Util.shuffleToken(bzbsToken);
                    switch (localeCode) {
                        case 1033:
                            strLocale = "E";
                            break;
                        case 1054:
                            strLocale = "T";
                            break;
                    }

                    if (
                        this.campaign.website.indexOf(".buzzebees.com/payment/")
                    ) {
                        var arrSplittedUrl = this.campaign.website.split(
                            "/payment"
                        );
                        strUrl =
                            Vue.bzbsConfig.bzbShoppingCartUrl +
                            "/payment" +
                            arrSplittedUrl[1] +
                            "&token=" +
                            strEncryptToken +
                            "&return_url=" +
                            returnUrl +
                            "&locale=" +
                            strLocale;
                    } else {
                        strUrl = this.campaign.website =
                            "&token=" +
                            strEncryptToken +
                            "&return_url=" +
                            returnUrl +
                            "&locale=" +
                            strLocale;
                    }

                    window.location = strUrl;
                    break;
                case Vue.CampaignType.Interface:
                    var isShowHeader = "false"; //show/hide header.
                    var strTheme = "";
                    window.location.href =
                        this.campaign.website +
                        "&token=" +
                        bzbsToken +
                        "&locale=" +
                        localeCode +
                        "&header=" +
                        isShowHeader +
                        "&theme=" +
                        strTheme +
                        "&return_url=" +
                        returnUrl; // ReturnUrl;
                    break;
            }
        },
        openSurvey: function() {},
        callInterfaceApi: function() {},
        //Shipping
        initialShippingAddress: function() {
            this.shippingAddress = Account.getCacheProfileShippingAddres();
            this.busShippingModal.$emit("showShippingAddressModal", {});
        },
        clickConfirmAddress: function() {
            if (!this.shippingAddressValidateInfo.isValid) {
                this.showAlertModal(
                    this.lbl.shipping.alert_headline,
                    this.shippingAddressValidateInfo.msg,
                    this.lbl.shipping.alert_ok_btn,
                    "shipping"
                );
            } else {
                this.redeemShippingAdress = new RedeemShippingAdressBuilder()
                    .initialWithProfileShippingAddress(this.shippingAddress)
                    .create();

                this.redeem();
            }
        },
        //Redeem
        redeem: function() {
            this.loadingModal.show();
            // if (!this.redeemBTN.isAllowRedeem) return;
            // var bzbsToken = Account.getToken();
            BzbsCampaign.apiRedeemCampaign(
                this.token,
                this.selectedId,
                this.redeemConfig,
                this.redeemShippingAdress,
                null,
                null,
                null
            )
                .then(campaign => {
                    console.log("campaign", campaign);
                    this.campaign.updateAfterRedeem(campaign);
                    var self = this;
                    setTimeout(function() {
                        self.updateCampaign();
                    }, 1000);
                    var redeemKey = campaign.RedeemKey;
                    return BzbsCampaign.apiUseRedeemKey(this.token, redeemKey);
                })
                .then(res => {
                    this.initialSerialModal();
                    console.log("use redeemkey success", res);
                })
                .catch(error => {
                    console.log(error);
                    this.showModalError(error);
                });
        },
        updateCampaign: function() {
            // var strBzbsToken = Account.getToken();
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaign.id)
                .create();
            BzbsCampaign.apiGetCampaignDetail(this.token, this.campaignConfig)
                .then(data => {
                    this.campaign.updateCampaign(data);
                    this.updateCampaignInfo(data);
                    this.forceRender();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        updateCampaignInfo: function(campaign) {
            this.$emit("updateCampaignInfo", campaign);
        },
        initialSerialModal: function() {
            this.loadingModal.hide();
            this.serialCampaign = this.campaign;
            this.busSerialModal.$emit("showSerialModal", this.serialCampaign);
        },
        showModalError: function(exception) {
            this.loadingModal.hide();
            var errRes = exception.response;
            errRes = errRes.data.error;
            var { id } = errRes;
            var msg = "";
            var localFail = this.lbl.after_redeem.titleFail;
            switch (id) {
                case 1:
                    msg = localFail.soldOut;
                    break;
                case 2:
                    msg = localFail.maxPerson;
                    break;
                case 3:
                    msg = localFail.interval;
                    break;
                case 1409:
                    msg = localFail.expire;
                    break;
                case 1302:
                    msg = localFail.noPoint;
                    break;
                case 404:
                    msg = errRes.message;
                    break;
                default:
                    msg = errRes.message;
                    break;
            }
            this.busErrorModal.$emit("showErrorModal", msg);
        },
        //Utilities
        forceRender: function() {
            this.isForceRender = false;

            this.$nextTick().then(() => {
                this.isForceRender = true;
            });
        },
        // --- modal event ----
        modalConfirmOk: function(event) {
            if (event.tag == "modal-redeem") {
                this.clickConfirmRedeem();
            }
        },
        // eslint-disable-next-line no-unused-vars
        showConfirmModal: function(title, message, btnOk, btnCancel, tag) {
            // var configModal = {
            //     title: title,
            //     message: message,
            //     strBtnOk: btnOk,
            //     strBtnCancel: btnCancel,
            //     tag: tag,
            // };
            // this.busModal.$emit('showConfirmModal', configModal);
        },
        // eslint-disable-next-line no-unused-vars
        showAlertModal: function(title, message, btnOk, tag) {
            // var configModal = {
            //     title: title,
            //     message: message,
            //     strBtnOk: btnOk,
            //     tag: tag,
            // };
            // this.busModal.$emit('showAlertModal', configModal);
        },
        clickOkModalAlert: function(e) {
            switch (e.tag) {
                case "shipping":
                    this.busShippingModal.$emit("showShippingAddressModal", {});
                    break;
            }
        },
        afterConfirmLastModal: function(text) {
            this.$emit("afterConfirmLastModal", text);
        }
    } // end methods
};
</script>
